// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"840":"1d999a8a","908":"df437640","924":"bc53bab4"}[chunkId] + ".css";
};